import _ from 'lodash';
import React from 'react';
import classNames from 'classnames';

import IconButton from 'components/IconButton';
import arrowDownIcon from 'assets/icons/arrow-down.svg';
import arrowRightIcon from 'assets/icons/arrow-right.svg';
import {toBoolean} from 'utils/common';

import './styles.css';

const DUMMY_ROOMS_SELECTED_VALUE: boolean = true;
const REAL_ROOMS_SELECTED_VALUE: boolean = false;
const NOTHING_SELECTED_VALUE: null = null;

interface AllocationTypesProps {
  value: boolean | null;
  onChange: (newAllocationType: boolean | null) => void;
}

class AllocationTypes extends React.Component<AllocationTypesProps> {
  onToggleReal = () => {
    if (this.getSelected().realRoomsSelected)
      return this.props.onChange(NOTHING_SELECTED_VALUE);

    return this.props.onChange(REAL_ROOMS_SELECTED_VALUE);
  };

  onToggleDummy = () => {
    if (this.getSelected().dummyRoomsSelected)
      return this.props.onChange(NOTHING_SELECTED_VALUE);

    return this.props.onChange(DUMMY_ROOMS_SELECTED_VALUE);
  };

  getSelected = () => {
    if (_.isNull(this.props.value)) {
      return {realRoomsSelected: false, dummyRoomsSelected: false};
    }

    return {
      realRoomsSelected:
        toBoolean(this.props.value) === REAL_ROOMS_SELECTED_VALUE,
      dummyRoomsSelected:
        toBoolean(this.props.value) === DUMMY_ROOMS_SELECTED_VALUE
    };
  };

  render() {
    const {realRoomsSelected, dummyRoomsSelected} = this.getSelected();

    return (
      <div className="AllocationType">
        <div
          className={classNames(
            'AllocationType__box colab-centered-v colab-centered-h colab-bold colab-clickable',
            {
              active: realRoomsSelected
            }
          )}
          onClick={this.onToggleReal}>
          Real
        </div>
        <div
          className={classNames(
            'AllocationType__box colab-centered-v colab-centered-h colab-bold colab-clickable',
            {
              active: dummyRoomsSelected
            }
          )}
          onClick={this.onToggleDummy}>
          Dummy
        </div>
      </div>
    );
  }
}

interface AllocationTypeFilterProps {
  value: boolean | null;
  classNameForTesting?: string;
  onChange: (mewAllocationType: boolean | null) => void;
}

class AllocationTypeFilter extends React.Component<AllocationTypeFilterProps> {
  state = {
    sectionOpened: false
  };

  toggleSection = () => {
    this.setState({sectionOpened: !this.state.sectionOpened});
  };

  render() {
    return (
      <div
        className={classNames(
          'FilterSection',
          {
            'FilterSection--opened': this.state.sectionOpened
          },
          this.props.classNameForTesting
        )}>
        <div className="FilterSection__header colab-centered-v colab-bold">
          <IconButton
            src={arrowRightIcon}
            srcActive={arrowDownIcon}
            alt="Toggle section"
            onClick={this.toggleSection}
            active={this.state.sectionOpened}
          />
          <div>Allocation Type</div>
        </div>

        <div className="FilterSection__content">
          <AllocationTypes
            value={this.props.value}
            onChange={this.props.onChange}
          />
        </div>
      </div>
    );
  }
}

export default AllocationTypeFilter;
